(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }
  }
  customElements.define('header-wrapper', HeaderWrapper);

  // Виправлений клас StickyHeader
  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
      this.isTransitioning = false; // Флаг для запобігання конфліктів
      this.currentState = null; // Поточний стан логотипу
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();

      // Застосовуємо початкові стилі без transition
      this.applyHomepageLogoFilter(false);

      document.addEventListener('DOMContentLoaded', () => {
        this.setupCartTrigger();
      });
    }

    setupCartTrigger() {
      const desktopTrigger = document.getElementById('desktop-cart-trigger');
      const mobileTrigger = document.getElementById('mobile-cart-trigger');

      if (desktopTrigger && mobileTrigger) {
        desktopTrigger.addEventListener('click', () => {
          mobileTrigger.click();
        });
      }

      this.setupOverlayClose();
      this.updateCartCounter();
      setInterval(() => {
        this.updateCartCounter();
      }, 3000);
    }

    setupOverlayClose() {
      const cartContainer = document.querySelector('.cart-drawer-container');
      if (cartContainer) {
        cartContainer.addEventListener('click', (e) => {
          if (e.target === cartContainer && cartContainer.hasAttribute('open')) {
            const summary = cartContainer.querySelector('summary');
            if (summary) {
              summary.click();
            }
          }
        });
      }
    }

    updateCartCounter() {
      // fetch('/cart.js')
      //   .then(response => response.json())
      //   .then(data => {
      //     const count = data.item_count || 0;

      //     const desktopTrigger = document.getElementById('desktop-cart-trigger');
      //     if (desktopTrigger) {
      //       desktopTrigger.textContent = `CART${count > 0 ? ` (${count})` : ' (0)'}`;
      //     }

      //     const cartBubbles = document.querySelectorAll('.cart-count-bubble');
      //     cartBubbles.forEach(bubble => {
      //       const countSpan = bubble.querySelector('span[aria-hidden="true"]');
      //       if (countSpan) {
      //         countSpan.textContent = count;
      //       }
      //       bubble.style.display = count > 0 ? 'flex' : 'none';
      //     });
      //   })
      //   .catch(() => {});
    }

    // Виправлена функція з флагом для transition
    applyHomepageLogoFilter(withTransition = true) {
      if (this.isTransitioning) return; // Запобігаємо конфліктам

      const isHome = window.location.pathname === '/' || document.body.classList.contains('template-index');
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Визначаємо потрібний стан
      const newState = (isHome && scrollTop === 0) ? 'inverted' : 'normal';

      // Якщо стан не змінився, не робимо нічого
      if (this.currentState === newState) return;

      this.isTransitioning = true;
      this.currentState = newState;

      const headerLogosDesktop = document.querySelectorAll('.header__heading-logo.small-hide svg');
      const headerLogosMobile = document.querySelectorAll('.header__heading-logo.large-up-hide svg');
      const headerRightText = document.querySelector('.header__right-text');
      const headerMenuItems = document.querySelectorAll('.header__menu-item--top');
      const header = document.querySelector('.header-wrapper');

      // Встановлюємо transition тільки коли потрібно
      const transitionValue = withTransition ? 'color 0.3s ease' : 'none';

      if (newState === 'inverted') {
        // Стан для головної сторінки на топі
        if (header) {
          header.style.transition = withTransition ? 'background-color 0.3s ease, color 0.3s ease' : 'none';
          header.style.backgroundColor = '';
          header.style.color = 'rgb(var(--color-header-transparent))';
        }

        headerLogosDesktop.forEach(logo => {
          logo.style.transition = transitionValue;
          logo.style.filter = '';
          logo.style.color = '#e8c8d8';
        });
        headerLogosMobile.forEach(logo => {
          logo.style.transition = transitionValue;
          logo.style.filter = '';
          logo.style.color = '#e8c8d8';
        });
        if (headerRightText) {
          headerRightText.style.color = 'rgb(var(--color-header-transparent))';
        }
        headerMenuItems.forEach(item => {
          item.style.transition = transitionValue;
          item.style.color = 'rgb(var(--color-header-transparent))';
        });
      } else {
        // Нормальний стан
        if (header) {
          header.style.transition = withTransition ? 'background-color 0.3s ease, color 0.3s ease' : 'none';
          header.style.backgroundColor = '#ffffff';
        }

        headerLogosDesktop.forEach(logo => {
          logo.style.transition = transitionValue;
          logo.style.filter = '';
          logo.style.color = '#e8c8d8';
        });
        headerLogosMobile.forEach(logo => {
          logo.style.transition = transitionValue;
          logo.style.filter = '';
          logo.style.color = '#e8c8d8';
        });
        if (headerRightText) {
          headerRightText.style.color = 'rgb(var(--color-header-foreground))';
        }
        headerMenuItems.forEach(item => {
          item.style.transition = transitionValue;
          item.style.color = 'rgb(var(--color-header-foreground))';
        });
      }

      // Знімаємо флаг після завершення transition
      setTimeout(() => {
        this.isTransitioning = false;
      }, withTransition ? 300 : 0);
    }

    disconnectedCallback() {
      super.disconnectedCallback();
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    // Спрощена функція onScroll
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Викликаємо функцію зміни логотипу тільки коли це необхідно
      this.applyHomepageLogoFilter(true);

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);
            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;

          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
